import { Button } from "antd";
import React from "react";
import styled from "styled-components";
import buttonGreenBg from "../../../../../../assets/images/Event-2025/bg-popup-btn-green.png";
import buttonSmallGreenBg from "../../../../../../assets/images/Event-2025/bg-popup-btn-sm-green.png";
import buttonSmallBlueBg from "../../../../../../assets/images/Event-2025/bg-popup-btn-sm-blue.png";
import {
  POPUP_VARIANT_EVENT_THINGYAN_2025 as VARIANT,
  POPUP_TYPE_EVENT_THINGYAN_2025 as TYPE,
} from "../../../../../../helper/const";
import { useNavigate } from "react-router";
import PATH from "../../../../../../config/PATH";
import { useTranslation } from "react-i18next";

const Footer = ({ type, variant, noteText, buttonText, noFooterButton, handleActionBtn = () => {} }) => {
  const navigate = useNavigate()
  const {t} = useTranslation()
  return (
    <FooterContainer className="popup-footer" type={type}>
      {variant === VARIANT.surfacePiece ? (
        <div className="popup-footer__button-wrapper">
          <Button className="popup-footer__button small small-blue" onClick={handleActionBtn}>
            {buttonText || t("event_thingyan.piece_collection.earn_more_piece")}
          </Button>
          <Button className="popup-footer__button small small-green" onClick={() => navigate(PATH.PACKAGE)}>
            {buttonText || t("event_thingyan.pop_up.earn_more_super")}
          </Button>
        </div>
      ) : variant === VARIANT.surfaceComplete || noFooterButton ? null : (
        <Button
          className={`popup-footer__button ${
            type === TYPE.invite ? "shrikhand fz-auto" : ""
          }`}
          type="primary"
          onClick={handleActionBtn}
        >
          {buttonText || t("event_thingyan.piece_collection.earn_more_piece")}
        </Button>
      )}

      {noteText ? (
        <p className="popup-footer__note">
          <span dangerouslySetInnerHTML={{ __html: noteText }} />
        </p>
      ) : null}
    </FooterContainer>
  );
};

export default Footer;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: space-between;
  gap: 10px;

  .fz-auto{
    font-size: inherit !important;
    -webkit-text-stroke: 1px rgba(23, 110, 229, 1) !important;
  }

  .popup-footer__button-wrapper {
    display: flex;
    justify-content: center;
    gap: 16px;
  }

  .popup-footer__button {
    background-image: url(${buttonGreenBg});
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: transparent;
    width: 352px;
    height: 68px;
    border: none;
    border-radius: 25px;
    // flex: 1;

    &:hover,
    &:focus,
    &:active {
      background-image: url(${buttonGreenBg}) !important;
      background-size: contain !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
      background-color: transparent !important;
    }

    & > span {
      color: white;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }

    &.small {
      width: 194px;
      height: 49px;
      border-radius: 15px;
      & > span {
        font-size: 18px;
        white-space: initial;
        line-height: 1;
        max-width: 100%;
      }
    }

    &.small-blue {
      background-image: url(${buttonSmallBlueBg});
    }
    &.small-green {
      background-image: url(${buttonSmallGreenBg});
    }

    @media (max-width: 452px) {
      & > span {
        font-size: 18px;
      }

      &.small {
        & > span {
          font-size: 16px;
        }
      }
    }

    @media (max-width: 425px) {
      width: 300px;

      &.small {
        width: 160px;
        & > span {
          font-size: 14px;
        }
      }
    }

    @media (max-width: 350px) {
      &.small {
        width: 140px;

        & > span {
          font-size: 12px;
        }
      }
    }
  }

  .popup-footer__note {
    display: flex;
    font-size: 16px;
    color: #fff;
    font-style: italic;
    text-shadow: -1px -1px 0 rgba(23, 110, 229, 1),
      1px -1px 0 rgba(23, 110, 229, 1), -1px 1px 0 rgba(23, 110, 229, 1),
      1px 1px 0 rgba(23, 110, 229, 1);
    text-align: center;
    flex: 1;
    align-items: flex-end;
    & > span {
      font-weight: 500;
    }

    @media (max-width: 486px) {
      font-size: 14px;
    }

    @media (max-width: 452px) {
      font-size: 14px;
    }

    @media (max-width: 425px) {
      font-size: 12px;
    }

    @media (max-width: 350px) {
      font-size: 10px;
    }
  }
`;
